import iotDeviceFeatureConfigService from '../../../../services/iotDevice/iotDeviceFeatureConfigService';
import iotDeviceGlobalConfigService from '../../../../services/iotDevice/iotDeviceGlobalConfigService';
import iotDeviceSettingsService from '../../../../services/iotDevice/iotDeviceSettingsService';

const useGesturesEnabled = (iotDevice) => {
    const isEnabledGlobally = iotDeviceGlobalConfigService.isGlobalStatusGestures(iotDevice);
    const isFeatureEnabled = iotDeviceFeatureConfigService.isGesturesStatus();
    const isEnabled = iotDeviceSettingsService.isSettingAvailable(iotDevice, isEnabledGlobally, isFeatureEnabled);

    return isEnabled;
};

export default useGesturesEnabled;
